function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import get from 'lodash/get';
import keys from 'lodash/keys';
import pick from 'lodash/pick';
import cloneDeep from 'lodash/cloneDeep';
import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import DateOfBirthFormPartial from 'components/DateOfBirthFormPartial';
import App from 'modules/App';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import { formatObjectAsDate } from 'helpers/datetime';
import { useIsFormNotCompleted } from 'modules/App/hooks';
import { AppContext } from 'context';
import * as constants from '../../constants';
import { SIGN_UP_FORM } from '../../constants';
import messages from '../../messages';
import AccountValidator from '../../AccountValidator';
import { getStepValidationRules } from './helpers';
const Actions = ({ onBack, onContinue, isAlpineEnabled })=>{
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const values = get(formValues, 'values');
    const scope = get(values, 'scope');
    const stepValidatorRules = getStepValidationRules('UserInfo', scope, isAlpineEnabled);
    const stepValues = {
        values: pick(values, keys(stepValidatorRules))
    };
    const validateFormValue = App.hooks.useFormProcessing(SIGN_UP_FORM, ()=>onContinue(), {
        Validator: AccountValidator,
        isToUnfold: true
    });
    const onNext = ()=>{
        const dateOfBirthRules = {
            dateOfBirth: stepValidatorRules.dateOfBirth,
            'dateOfBirth.year': '*',
            'dateOfBirth.month': '*',
            'dateOfBirth.day': '*'
        };
        if (stepValidatorRules.dateOfBirthAsDateFormat) {
            validateFormValue({
                values: {
                    dateOfBirth: _object_spread({}, values.dateOfBirth)
                }
            }, dateOfBirthRules);
        } else {
            onContinue();
        }
    };
    const isContinueDisabled = useIsFormNotCompleted(cloneDeep(stepValues), stepValidatorRules);
    return /*#__PURE__*/ _jsxs("div", {
        className: "row flex-column-reverse flex-sm-row",
        children: [
            !isMobileDisplayMode && /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.back,
                    className: "btn--block",
                    onClick: onBack
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.continue,
                    className: "btn--block btn--filled",
                    isDisabled: isContinueDisabled,
                    onClick: onNext
                })
            })
        ]
    });
};
const UserInfo = ({ isFieldDisabled, onBack, onContinue })=>{
    const { isAlpineEnabled } = useContext(AppContext);
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const onSetValue = useAction(App.actions.setFormValue, SIGN_UP_FORM);
    const unsetFormValues = useAction(App.actions.unsetFormValues, SIGN_UP_FORM);
    const scope = get(formValues, 'values.scope');
    const values = get(formValues, 'values');
    const stepValidatorRules = getStepValidationRules('UserInfo', scope, isAlpineEnabled);
    const onSetDateOfBirth = (input)=>{
        onSetValue(input);
        const dateOfBirth = input.value;
        if (dateOfBirth && dateOfBirth.year && dateOfBirth.month && dateOfBirth.day) {
            onSetValue({
                id: 'dateOfBirthAsDateFormat',
                value: formatObjectAsDate(dateOfBirth)
            });
        } else if (values.dateOfBirthAsDateFormat) {
            unsetFormValues('dateOfBirthAsDateFormat');
        }
    };
    useEffect(()=>{
        if (values && values.dateOfBirth && !stepValidatorRules.dateOfBirthAsDateFormat) {
            unsetFormValues('dateOfBirthAsDateFormat');
            unsetFormValues('dateOfBirth');
        }
    }, []);
    const isPersonal = scope === constants.SCOPE_NAMES.PERSONAL;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(FormGroup, {
                        id: "firstName",
                        labelMessage: messages.labels.firstName,
                        formValues: formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: messages.placeholders.firstName,
                            isDisabled: isFieldDisabled('firstName'),
                            onChange: onSetValue
                        })
                    }),
                    /*#__PURE__*/ _jsx(FormGroup, {
                        id: "lastName",
                        labelMessage: messages.labels.lastName,
                        formValues: formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: messages.placeholders.lastName,
                            isDisabled: isFieldDisabled('lastName'),
                            onChange: onSetValue
                        })
                    }),
                    isPersonal && /*#__PURE__*/ _jsx(DateOfBirthFormPartial, {
                        formValues: formValues,
                        errorsMessages: messages.validatorRules,
                        onSetFormValue: onSetDateOfBirth
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Actions, {
                onBack: onBack,
                onContinue: onContinue,
                isAlpineEnabled: isAlpineEnabled
            })
        ]
    });
};
export default UserInfo;
